import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { QUERY_KEY_TO_PERSIST } from '../../../modules/offline/queryClient/offlineQueryClient';

export const getGetBrandContextKey = (): UseDataQuery['queryKey'] => [
  '/context/brands/v1',
  undefined,
  QUERY_KEY_TO_PERSIST,
];
